import { render, staticRenderFns } from "./OrderChooseDoctor.vue?vue&type=template&id=351b047c&scoped=true&"
import script from "./OrderChooseDoctor.vue?vue&type=script&lang=js&"
export * from "./OrderChooseDoctor.vue?vue&type=script&lang=js&"
import style0 from "./OrderChooseDoctor.vue?vue&type=style&index=0&id=351b047c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351b047c",
  null
  
)

export default component.exports